import { createTheme } from '@mui/material/styles'

export const getTheme = (mode, primary, secondary) => createTheme({
  palette: {
    mode: mode,
    primary: {
      main: primary
    },
    secondary: {
      main: secondary
    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: mode === 'dark' ? 'transparent' : 'white'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          // Fix for label/border overlap when TextField is conditionally rendered
          // Force proper background so label doesn't visually overlap border
          "&.MuiInputLabel-shrink": {
            backgroundColor: "inherit",
            paddingLeft: "4px",
            paddingRight: "4px",
            marginLeft: "-4px",
          },
        },
      },
    }
  }
})
